import { view } from "@/mega-ui/helpers/function"

export const support = {
    path: '/support',
    name: 'support',
    children: [
        {
            path: 'main',
            name: 'support-main',
            meta: {
                withAuth: true,
            },
            component: () => view('support/SupportMainView')
        },
        {
            path: 'contact',
            name: 'support-contact',
            meta: {
                withAuth: true,
            },
            component: () => view('support/SupportContactView')
        },
    ]
}